import { render } from "./CommentTable.vue?vue&type=template&id=8f382b84"
import script from "./CommentTable.vue?vue&type=script&lang=js"
export * from "./CommentTable.vue?vue&type=script&lang=js"

import "./CommentTable.vue?vue&type=style&index=0&id=8f382b84&lang=css"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__